import { Link } from "react-router-dom";
import styled from "styled-components";

const Container = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`

const Config = styled.div`
    width: 80%;
    padding: 10px 0;
    margin: 5% 0;
    display: flex; 
    justify-content: center;
    align-items: center;

    font-size: 1.1em;

    border: 1px solid #F99FC9;
    border-radius: 100px;
    background-color: #F99FC9;
`

const Item = styled.div`
    transition: 0.3s ease all;

    width: 50%;
    height: calc(100% + 20px);
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    color: ${props => props.active ? '#753BBD' : '#82899C'};

    border-radius: 100px;
`

const ListWrapper = styled.div`
    width: 100%;
    height: 90%;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: scroll;
`

const Wrapper = styled.div`
    width: 80%;
    height: 20%;
    max-height: 100px;
    min-height: 70px;
    margin: 8px 0;

    display: flex; 
    align-items: center;
    justify-content: center;

    background-color: white;

    // border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    text-decoration: none;
`

const Informative = styled.div`
    width: 80%;
    height: 100%;

    display: flex; 
    align-items: center;
    justify-content: space-between;

    text-decoration: none;
`

const TicketInfo = styled(Link)`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    height: 75%;

    text-decoration: none;
`

const Description = styled.div`
    color: gray;
    font-size: 0.8em;
`

const Price = styled.div`
    text-align: center;
    color: #753BBD;
    font-weight: bold;
`

const ButtonWrapper = styled.div`
    width: 80%;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
`

const ConfirmationWrapper = styled.div`
    width: 80%;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
`

const Button = styled.div`
    height: 8%;
    margin: 10px 0;
    min-height: 50px;
    width: 65%;
    align-self: center;
    
    text-align: center;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 15px;
    font-weight: bold;
    color: white;
    background-color: #470A68;
    text-decoration: none;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`

const ButtonLink = styled(Link)`
    height: 8%;
    margin: 10px 0;
    min-height: 50px;
    width: 25%;
    align-self: center;
    
    text-align: center;
    cursor: pointer;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 15px;
    font-weight: bold;
    color: white;
    background-color: #470A68;
    text-decoration: none;

    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`

export {
    Container, 
    Config,
    Item,
    ListWrapper,
    Wrapper,
    Informative,
    TicketInfo,
    Description,
    Price,
    ButtonWrapper,
    ConfirmationWrapper,
    Button,
    ButtonLink
}